import {PaginatorInfo} from "./generic.dto";
import {EmployeeBand, EmployeeBandDto} from "./employee-band.dto";
import { EmployeeDto } from "./employee.dto";
import { CustomTaxReliefGroupDto } from "./custom-tax-relief-group.dto";

export const GRADE_LEVEL_TYPE = {
  MAJOR: 'MAJOR',
  MINOR: 'MINOR'
};

export type GRADE_LEVEL_TYPE = (typeof GRADE_LEVEL_TYPE)[keyof typeof GRADE_LEVEL_TYPE]

type CustomTaxRelief = {
  id: number
  companyId: number
  code: string
  name: string
  amount: number
  description: string
  active: boolean
  groupId: number | null
  createdAt: string
  modifiedAt: string | null
}

export class CreateCustomTaxReliefDto {
  companyId!: number;
  code!: string;
  name!: string;
  amount!: number
  description!:string;
  active!: boolean;
  employeeIds?: number[]
  employeeBandIds?: number[]
  groupId?: number;
}

export class UpdateCustomTaxReliefDto {
  code?: string;
  name?: string;
  amount?: number
  description?:string;
  active?: boolean;
  addEmployeeIds?: number[];
  removeEmployeeIds?: number[];
  addEmployeeBandIds?: number[];
  removeEmployeeBandIds?: number[];
  groupId?: number;
}

export interface CustomTaxReliefDto extends CustomTaxRelief {
  employeeCustomTaxReliefs?: EmployeeCustomTaxReliefDto[];
  employeeBandCustomTaxReliefs?: EmployeeBandCustomTaxReliefDto[];
  group?: CustomTaxReliefGroupDto;
}

export interface EmployeeCustomTaxReliefDto extends EmployeeCustomTaxRelief {
  employee?: EmployeeDto;
}

export interface EmployeeBandCustomTaxReliefDto extends EmployeeBandCustomTaxRelief {
  employeeBand?: EmployeeBand;
}

type EmployeeCustomTaxRelief = {
  id: number;
  employeeId: number;
  customTaxReliefId: number;
  active: boolean;
  createdAt: string;
  modifiedAt: string | null;
}

type EmployeeBandCustomTaxRelief = {
  id: number;
  employeeBandId: number;
  customTaxReliefId: number;
  active: boolean;
  createdAt: string;
  modifiedAt: string | null;
}

export interface CustomTaxReliefPaginator extends PaginatorInfo<CustomTaxReliefDto> {}

export class QueryCustomTaxReliefDto {
  companyId?: number;
  code?: string;
  active?: boolean;
  groupId?: number;
  page?: number = 1;
  limit?: number;
  orderBy?: CustomTaxReliefOrderBy = CustomTaxReliefOrderBy.CREATED_AT_ASC;
}

export class SearchCustomTaxReliefDto {
  q?: string;
  companyId?: number;
  page?: number = 1;
  limit?: number;
  orderBy?: CustomTaxReliefOrderBy = CustomTaxReliefOrderBy.CREATED_AT_ASC;
}

export enum CustomTaxReliefOrderBy {
  CODE_ASC = 'code:asc',
  CODE_DESC = 'code:desc',
  NAME_ASC = 'name:asc',
  NAME_DESC = 'name:desc',
  CREATED_AT_ASC = 'createdAt:asc',
  CREATED_AT_DESC = 'createdAt:desc',
  MODIFIED_AT_ASC = 'modifiedAt:asc',
  MODIFIED_AT_DESC = 'modifiedAt:desc',
}

export class UploadCustomTaxReliefsResponse {
  successful!: {
    customTaxReliefId?: number;
    rowNumber?: number;
  }[];
  failed!: {
    rowNumber?: number;
    errors: {
      column: string;
      reason: string;
    }[]
  }[];
}

export interface QueryCustomTaxReliefNoPaginationDto extends Omit<QueryCustomTaxReliefDto, 'page' | 'limit'> {};

export class ExportCustomTaxReliefQueryDto {
  customTaxReliefCode?: boolean;
  customTaxReliefName?: boolean;
  description?: boolean;
  amount?: boolean;
  active?: boolean;
  reliefTypeId?: boolean;
  groupCode?: string;
  orderBy: CustomTaxReliefOrderBy = CustomTaxReliefOrderBy.CREATED_AT_ASC;
}